import { getDocumentVisibilityState } from "@/shared/hooks/useDocumentVisibilityState";

export const CATALOG_AUTO_RELOAD_INTERVAL = 60_000;
export const CATALOG_BACKGROUND_AUTO_RELOAD_INTERVAL = 5 * 60_000;

export const CATALOG_QUERY_BEHAVIOR = {
  staleTime: 30_000,
  refetchOnWindowFocus: true,
  refetchIntervalInBackground: true,
} as const;

export function getCatalogRefetchInterval(
  enabled: boolean,
  visibilityState: DocumentVisibilityState,
): number | false {
  if (!enabled) return false;
  return visibilityState === "visible"
    ? CATALOG_AUTO_RELOAD_INTERVAL
    : CATALOG_BACKGROUND_AUTO_RELOAD_INTERVAL;
}

type CatalogAutoReloadQueryBehavior = typeof CATALOG_QUERY_BEHAVIOR & {
  refetchInterval: () => number | false;
};

export function createCatalogAutoReloadQueryBehavior(
  enabled: boolean,
  readVisibilityState: () => DocumentVisibilityState = getDocumentVisibilityState,
): CatalogAutoReloadQueryBehavior {
  return {
    ...CATALOG_QUERY_BEHAVIOR,
    refetchInterval: (): number | false =>
      getCatalogRefetchInterval(enabled, readVisibilityState()),
  };
}

export function shouldRefreshCatalogOnlineUsers(
  autoReloadEnabled: boolean,
  isInitialFetch: boolean,
  visibilityState: DocumentVisibilityState,
): boolean {
  return !autoReloadEnabled || isInitialFetch || visibilityState === "visible";
}
